import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './firebase'; // ← 追加（Firebase初期化）
import App from './App';
import { applyTenantTheme } from './lib/tenantTheme';
import reportWebVitals from './reportWebVitals';

applyTenantTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();